var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6671 5.66083C25.2536 5.66083 29.7824 10.1896 29.7824 15.7762C29.7824 21.3627 25.2536 25.8915 19.6671 25.8915C14.0805 25.8915 9.55176 21.3627 9.55176 15.7762C9.55176 10.1896 14.0805 5.66083 19.6671 5.66083",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8857 25.8914H27.4478",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 11.9228V10.6383",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 19.6298V20.9142",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4397 18.7126C17.7698 19.276 18.3718 19.6243 19.0248 19.6297H20.4377C21.3629 19.6528 22.1546 18.97 22.2675 18.0514C22.3804 17.1328 21.7777 16.2785 20.8744 16.0769L18.4673 15.4719C17.5746 15.2628 16.9822 14.4155 17.0922 13.5053C17.2023 12.595 17.9795 11.9133 18.8963 11.9229H20.3092C20.9628 11.9273 21.5656 12.2758 21.8956 12.84",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0056 19.6667H30.5604C32.2793 19.6667 33.6728 21.0602 33.6728 22.7791V30.5601C33.6728 32.279 32.2793 33.6725 30.5604 33.6725H8.77354C7.05461 33.6725 5.66113 32.279 5.66113 30.5601V22.7791C5.66113 21.0602 7.05461 19.6667 8.77354 19.6667H10.3284",
    stroke: "#0074B2",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.b8e12900e92a2bf090782c36e24a2cef.svg";
export { ForwardRef as ReactComponent };